import React, { createContext, FC, useContext, useMemo } from 'react';

interface SuggestionContainerProviderData {
  ref: React.ForwardedRef<HTMLDivElement> | null;
}

const defaultSuggestionContainerRef: SuggestionContainerProviderData = {
  ref: null,
};

const SuggestionContainerRefContext = createContext(defaultSuggestionContainerRef);

export const SuggestionContainerRefProvider: FC<{
  children: React.ReactNode;
  containerRef: React.ForwardedRef<HTMLDivElement>;
}> = ({ children, containerRef: ref }) => {
  // HACK: оборачивать в  useMemo требует сонар
  const value = useMemo(() => {
    return { ref };
  }, [ref]);
  return (
    <SuggestionContainerRefContext.Provider value={value}>{children}</SuggestionContainerRefContext.Provider>
  );
};

export const useSuggestionContainerRefContext = () => useContext(SuggestionContainerRefContext);
